<template>
  <div
    :id="`Advantages1-${pageUid}`"
    :class="`c-${featureTextColor} bg-${backgroundColor}`"
    class="advantages advantages1 advantages--1 lp-section advantages-container width-expand">
    <div class="container container-l padding-max-vertical">
      <h2 class="text-max c-alt text-center" :class="`c-${titleColor}`">
        <span>{{ title }}</span>
      </h2>
      <div class="advantages-container width-expand">
        <div
          v-for="feature of features"
          class="advantage-item flex-column flex-center-middle">
          <div class="advantage-item__icon-container">
            <img
              class="advantage-item__icon"
              :src="feature.image"
              :alt="feature.title" />
          </div>
          <div class="advantage-item__title" v-if="isNonEmptyString(feature.title)"
               :class="`c-${featureTitleColor}`">
            <h3>{{ feature.title }}</h3>
          </div>
          <div class="advantage-item__text" :class="`c-${featureTextColor}`">
            <p v-html="nl2Br(feature.text)"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useUiElements from "@/client/extensions/composition/useUiElements";
import lpSectionMixin from "@/client/applications/meitavlp/extensions/mixins/lpSection";
import { inject } from "vue";

export default {
  mixins: [lpSectionMixin],

  setup(props) {
    let pageUid = inject("pageUid");

    let schema = {
      title: "",
      features: [
        {
          mainTitle: "",
          title: "",
          image: {},
          text: "",
        },
      ],
      backgroundColor: "",
      titleColor: "",
      featureTitleColor: "",
      featureTextColor: "",
      trackEvent: () => {},
      track: () => {},
      triggerSectionsEvent: () => {},
      pageUid,
    };
    let overloadedProps = useUiElements({ input: props.sectionData }).props;
    return {
      ...schema,
      ...overloadedProps,
      allData: overloadedProps,
      pageUid,
      trackEvent: inject("trackEvent"),
      track: inject("track"),
      triggerSectionsEvent: inject("triggerSectionsEvent"),
    };
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    async testMethod() {
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.advantages1 {
  h2 {
    font-size: var(--font-max);
    font-weight: 600;
    line-height: 0.75;
    margin-bottom: var(--margin-2xl);
  }

  .advantages-container {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: calc(var(--margin-2xl));

    @media (max-width: 1024px) {
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      gap: calc(var(--margin-2xl) * 1.2);
    }
  }

  .advantage-item {
    max-width: 260px;
    min-width: 200px;
    text-align: center;

    &__icon {
      max-width: 105px;
      max-height: 105px;
      margin-bottom: var(--margin-l);
    }

    &__title {
      color: var(--c-lead-2);
      margin-bottom: 0;
      line-height: 0.8;

      h3 {
        font-size: var(--font-2xl);
        font-weight: 600;
        margin-bottom: var(--margin-l);
      }
    }

    &__text {
      p {
        font-size: var(--font-2xl);
        line-height: 1;
      }
    }
  }
}
</style>
